<!-- START Search form-->
<form class="navbar-form" role="search" action="search.html" [class.open]="visible" (submit)="submitValue()">
  <div class="form-group">
    <input class="form-control" type="text" [formControl]="queryField" placeholder="Type the keyword(s) for searching" />
    <div class="fa fa-times navbar-form-close" (click)="closeNavSearch()"></div>
  </div>
  <button class="d-none" type="submit">Submit</button>
  <app-spinner *ngIf="visible && searching"></app-spinner>
  <div *ngIf="visible && searchResults != null" class="dropdown-menu show">
    <a *ngIf="searchResults.length == 0" href="#" class="dropdown-item">
      <div class="d-flex w-100 justify-content-between">
        <h5 class="mb-1">Nothing found..</h5>
      </div>
    </a>
    <a *ngFor="let result of searchResults|slice:0:10" routerLink="/help/pagecontent" [queryParams]="{ id: result.id }" (click)="closeNavSearch()" class="list-group-item list-group-item-action">
      <div class="d-flex w-100 justify-content-between">
        <h5 class="mb-1">{{result.title}}</h5>
      </div>
      <div class="mb-1" [innerHtml]="result.content|slice:0:100"></div>
    </a>
  </div>
</form>
<!-- END Search form-->
